import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Div, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';
/* eslint-disable react/prop-types */

export function ConfirmDialog({ isOpen, actions }) {
  return (
    <BaseDialog
      isOpen={isOpen}
      actions={actions}
      title={{
        text: `Confirm Onboarding`,
        backgroundColor: 'teal',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Text key="confirm-onb-text-desc" textSize="paragraph" textWeight="500" textColor="shade66">
            Do you want to proceed with the onboarding?
          </Text>,
          <Div key="confirm-onb-spacer" data-test="last-spacer" h="1.875rem" m={{ t: '1.25rem' }} />,
        ],
        buttons: [
          {
            text: 'YES',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.oneOfType([PropTypes.func, undefined]),
      on: PropTypes.func.isRequired,
      after: PropTypes.oneOfType([PropTypes.func, undefined]),
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.oneOfType([PropTypes.func, undefined]),
      on: PropTypes.func.isRequired,
      after: PropTypes.oneOfType([PropTypes.func, undefined]),
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.oneOfType([PropTypes.func, undefined]),
        on: PropTypes.func.isRequired,
        after: PropTypes.oneOfType([PropTypes.func, undefined]),
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
};
/* eslint-enable */

export default ConfirmDialog;
